export default __webpack_public_path__ + "static/media/grafema_ciceco_06.9e8b53d3.jpg";